import { getBaseAppPath } from "../configs";

const baseAppPath = getBaseAppPath();

export const ROUTES = {
  ROOT: baseAppPath,
} as const;
